import { nanoid } from "@reduxjs/toolkit";
import { ChangeEventHandler, useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import Option from "../components/Option";
import { getOnlyUnique } from "../components/commonWidget";
import chartIcon from "../components/custom/assets/images/dashboard/chart_icon.svg";
import FormInput2 from "../components/custom/components/FormInput2";
import {
  Tbody,
  Thead,
} from "../components/custom/components/TradeCategoryPerformanceTable";
import TransactionTable from "../components/custom/components/TransactionTable";
import BubbleChart from "../components/custom/components/charts/apex/BubbleChart";
import { COLORS } from "../components/custom/constants";
import UserLayout from "../components/custom/layouts/UserLayout";
import { ToastTypes, useToast } from "../components/toast/ToastProvider";
import {defaultbrand, defaultLocation, defaultPortfolio, defaultTradeCategory, defaultTradeSubCategory, DropDownOption1, PAGE_SIZE } from "../config";
import api, { APIResponse, getAxiosRequestConfig } from "../config/api";
import {
  CSVdownload,
  handleDownloadPDF,
} from "../config/functions";
import { AuthUserType } from "../redux/actions/authUserActions";
import { BrandType } from "../redux/actions/brandActions";
import { BrandCompanyType } from "../redux/actions/brandCompanyActions";
import { PortfolioType } from "../redux/actions/portfolioActions";
import {
  OptionsTypes,
  addToSelectedOption,
} from "../redux/actions/selectedOptionsActions";
import { SiteType } from "../redux/actions/siteActions";
import { TradeCategoryType } from "../redux/actions/tradeCategoryActions";
import { TradeSubCategoryType } from "../redux/actions/tradeSubCategoryActions";
import { StoreState } from "../redux/store";
import { CatSubCatCompanyWithBrandRelationDataType } from "./TransactionBillWiseReport";
import Loader from "../components/custom/components/Loader";
import Modal from "../components/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowMaximize } from "@fortawesome/free-solid-svg-icons";
import { areaType } from "../redux/actions/areaActions";
import { outletType } from "../redux/actions/outletActions";
import { useLocation } from "react-router-dom";
import { UserLog } from "../config/common";
import SingleSelect from "../components/custom/components/SingleSelect";
import SingleSelect1 from "../components/custom/components/SingleSelect1";

export interface DropDownOption {
  value: number;
  label: string;
  imgUrl: string;
}

export interface SalesTradingDensityRecord {
  brand: number;
  sales: string;
  transyear: number;
}

export interface SalesTradingDensityReportType {
  portfolio: number;
  record: SalesTradingDensityRecord[];
  count?: number;
}

export interface BuildingType {
  centerid: number;
  buildingid: number;
  buildingname: string;
  buildingcode: string;
}

export interface BuildingDataType {
  portfolio: number;
  record: BuildingType[];
}

export interface FloorType {
  centerid: number;
  buildingid: number;
  floorid: number;
  floorname: string;
  floorcode: string;
}

export interface FloorDataType {
  portfolio: number;
  record: FloorType[];
}

const SalesTradingDensityReport = () => {
  const toast = useToast();
  const dispatch = useDispatch();
  const pageName = useLocation()
  const authUser = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  );
  const authUserToken = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  )?.["auth-token"]!;
  const config = getAxiosRequestConfig(authUserToken);

  const authUserSiteId = authUser?.siteId;

  const portfolioOption = useSelector<StoreState, PortfolioType[]>(
    (state) => state?.portfolio
  );
  const siteOption = useSelector<StoreState, SiteType[]>((state) => state?.site);
  const brandOption = useSelector<StoreState, BrandType[]>(
    (state) => state?.brand
  );
  const brandCompanyOption = useSelector<StoreState, BrandCompanyType[]>(
    (state) => state?.brandCompany
  );
  const outletList = useSelector<StoreState, outletType[]>(
    (state) => state?.outlet
  );
  const selectedOption = useSelector<StoreState, OptionsTypes>(
    (state) => state?.selectedOption
  );
  const filteredBrand = brandOption?.filter((a) => {
    return brandCompanyOption?.some(
      (b) => b?.id?.toString() === a?.companyid?.toString() && b?.retailid !== null
    );
  });

  const port =
    authUser?.portfolioId !== undefined && authUser?.portfolioId !== null
      ? authUser?.portfolioId?.split(",")
      : [];

  let portfolioData = port
    ?.map((pe) => {
      return portfolioOption?.filter(
        (f) => f?.id?.toString() === pe?.toString()
      );
    })
    ?.flat(1);

  const pname = portfolioData[0]?.name;

  const st =
    authUser?.siteId !== undefined && authUser?.siteId !== null
      ? authUser?.siteId?.split(",")
      : [];

  let siteData = st
    ?.map((pe) => {
      return siteOption?.filter((f) => f?.id?.toString() === pe?.toString());
    })
    ?.flat(1);
  const localityOption = useSelector<StoreState, areaType[]>(
    (state) => state?.locality
  );
  const categoryOption = useSelector<StoreState, TradeCategoryType[]>(
    (state) => state?.tradeCategory
  );
  const subCategoryOption = useSelector<StoreState, TradeSubCategoryType[]>(
    (state) => state?.tradeSubCategory
  );

  const [
    catSubCatCompanyWithBrandRelationData,
    setCatSubCatCompanyWithBrandRelationData,
  ] = useState<CatSubCatCompanyWithBrandRelationDataType[]>([]);

  const [year, setYear] = useState<Date>(new Date());

  const [valueIn, setValueIn] = useState<string>("");

  const [portfolios, setPortfolios] = useState<string>("");
  const [sites, setSites] = useState<string>("");
  const [brands, setBrands] = useState<string>("");

  const [location, setLocation] = useState<string>("");
  const [categories, setCategories] = useState<string>("");
  const [subCategories, setSubCategories] = useState<string>("");

  //loader
  const [loader, setLoader] = useState<boolean>(false);

  const [salesTradingDensityData, setSalesTradingDensityData] = useState<
    SalesTradingDensityReportType[]
  >([]);

  const limit = PAGE_SIZE;
  const [offset, setOffset] = useState<number>(0);
  const [range, setRange] = useState<number[]>([]);
  const [length, setLength] = useState<number>(50);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [isButtonVisible, setButtonVisible] = useState(false);
  const [disableLocality, setDisableLocality] = useState<boolean>(false);
  const [condition,setCondition] = useState<boolean>(false)

  const [portfoliosOption, setPortfoliosOption] = useState<DropDownOption1>(defaultPortfolio);
  const  [locationOption,setLocationOption] = useState<DropDownOption1>(defaultLocation)
  const [categoriesOption, setCategoriesOption] = useState<DropDownOption1>(defaultTradeCategory);
  const [subCategoriesOption, setSubcategoriesOption] = useState<DropDownOption1>(defaultTradeSubCategory);

  
  const [portfolioDrop, setPortfolioDrop] = useState<DropDownOption[]>([]);
  const [locationDrop, setLocationDrop] = useState<DropDownOption[]>([]);
  const [catDrop,setCatDrop] = useState<DropDownOption[]>([])
  const [subcatDrop,setSubcatDrop] = useState<DropDownOption[]>([])

  const showExpandModalHandler = () => {
    setShowModal(true)
  };

  const handleSelectedRowsChange = (selectedRows: string[]) => {
    setSelectedRows(selectedRows);
  };

  const handleOff = (conditionVal: boolean) => {
    setCondition(conditionVal);
  };


  const SiteFilteredByPortfolio = useMemo<SiteType[]>(() => {
    if (portfolios !== "") {
      return siteData?.filter((s) => {
        return s?.pfid?.toString() === portfolios?.toString();
      });
    } else return [];
  }, [portfolios, siteData]);

  const subCategoryFilteredByCategory = useMemo<TradeSubCategoryType[]>(() => {
    if (categories !== "") {
      return subCategoryOption?.filter((sc) => {
        return sc?.catid?.toString() === categories?.toString();
      });
    } else return subCategoryOption;
  }, [categories, subCategoryOption]);
  

  const handlePortfolioDrop = (selected: any) => {
    if(selected.length>0){
      const selectedPortfolio = selected as DropDownOption[];
      if(selectedPortfolio[0].value!==null&&selectedPortfolio[0].value!==0){
        setPortfolioDrop(selectedPortfolio)
        setPortfolios(selectedPortfolio[0]?.value?.toString())
        const data = { ...selectedOption, portfolio: selectedPortfolio[0]?.value?.toString() };
        dispatch(addToSelectedOption(data));
        setOffset(0);
      }
  }
  };
  
  const handleClearPortfolio = () =>{
    let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
    setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
    const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl: b[0]?.logourl, 
      };
      setPortfolioDrop([val]);
      setLocation("");
      setLocationDrop([])
      const data = { ...selectedOption, portfolio: b[0]?.id?.toString(),location:''};
      dispatch(addToSelectedOption(data));
      setOffset(0);
  }
  }
  
  
  const handleLocationDrop = (selected: any) => {
    if(selected.length>0){
      const selectedLocation = selected as DropDownOption[];
      if(selectedLocation[0].value!==null&&selectedLocation[0].value!==0){
        setLocationDrop(selectedLocation)
        setLocation(selectedLocation[0]?.label?.toString())
       const data = { ...selectedOption,location: selectedLocation[0]?.label?.toString()};
       dispatch(addToSelectedOption(data));
       setOffset(0);
      }
    }
  };
  
  const handleClearLocation = () =>{
       setLocationDrop([])
       setLocation('')
       const data = { ...selectedOption,location: ""};
       dispatch(addToSelectedOption(data));
       setOffset(0);
  }
  
  const handleCatDrop = (selected: any) => {
    if(selected.length>0){
      const selectedCat = selected as DropDownOption[];
      if(selectedCat[0].value!==null&&selectedCat[0].value!==0){
        setCatDrop(selectedCat)
        setCategories(selectedCat[0]?.value?.toString())
        setSubcatDrop([])
        setSubCategories('')
        const data = {
          ...selectedOption,
          category: selectedCat[0]?.value?.toString(),
          subCategory: "",
          brand: "",
          brands:[]
        };
        dispatch(addToSelectedOption(data));
        setOffset(0);
      }
  }
  };
  
  const handleClearCat = () =>{
      setCatDrop([])
      setCategories('')
      setSubcatDrop([])
        setSubCategories('')
       const data = { ...selectedOption,
        category: '',
        subCategory: "",
        brand: "",brands:[]};
       dispatch(addToSelectedOption(data));
       setOffset(0); 
  }

  const handleSubcatDrop = (selected: any) => {
    if(selected.length>0){
      const selectedSubcat = selected as DropDownOption[];
      if(selectedSubcat[0].value!==null&&selectedSubcat[0].value!==0){
        setSubcatDrop(selectedSubcat)
        setSubCategories(selectedSubcat[0]?.value?.toString())
        const data = { ...selectedOption,
          subCategory: selectedSubcat[0]?.value?.toString(),
          brand: "",brands:[]};
         dispatch(addToSelectedOption(data));
         setOffset(0);
      }
  }
  };
  
  const handleClearSubcat = () =>{
      setSubcatDrop([])
        setSubCategories('')
       const data = { ...selectedOption,
        subCategory: "",
        brand: "",brands:[]};
       dispatch(addToSelectedOption(data));
       setOffset(0);
  }

  const portFilter = portfolioOption?.filter((a)=>a?.id?.toString()===portfolios?.toString())
  const catFilter = categoryOption?.filter((a)=>a?.id?.toString()===categories?.toString())
  const subcatFilter = subCategoryOption?.filter((a)=>a?.id?.toString()===subCategories?.toString())
  const localityFilter = localityOption?.filter((a)=>a?.area?.toString()===location?.toString())


  const combinedValues = [
    ...portFilter?.map(a => `Portfolio: ${a?.name}`),           
    ...catFilter?.map(c=> `Trade Category: ${c?.name}`),
    ...subcatFilter?.map(d=> `Trade Sub Category: ${d?.name}`),
   
    ...localityFilter?.map(f=>`Locality: ${f?.area}`),     
    `Year: ${year?.getFullYear()}`,
  ]
  ?.filter(name => name && name?.trim() !== '') 
  ?.join(', ');  

  const tHead = useMemo<Thead[]>(() => {
    var theadArray: {
      id: string;
      children: string;
      text: string;
    }[] = [
      { id: "Brand", children: "Brand", text: "Brand" },
      { id: "NetSales", children: "NetSales", text: "NetSales" },
    ];

    return theadArray;
  }, []);

  const getDownloadData = (
    Data: {
      portfolio: number;
      record: SalesTradingDensityRecord[];
      count?: number;
    }[]
  ) => {
    var tableHead: Thead[] = tHead;
    var tableBody: Tbody[][] = [];

    const tbody = Data;

    Data?.forEach((y, i) => {

      const brandArray = y?.record?.map((r, j) => r?.brand)?.filter(getOnlyUnique);

      brandArray?.forEach((br, j) => {
        var tBody: Tbody[] = [];
        const brandIndex = filteredBrand?.findIndex(
          (c) => c?.id !== undefined && c?.id?.toString() === br?.toString()
        );
        const brandName = filteredBrand[brandIndex]?.name;
        const brandId = br;

        tBody?.push({
          id: "Brand" + brandId + j,
          theadId: "Brand",
          children: brandName,
          text: brandName,
        });
        y?.record
          ?.filter((r) => r?.brand?.toString() === brandId?.toString())
          ?.forEach((r, i) => {
            tBody?.push({
              id: r?.sales?.toString() + i,
              children: r?.sales,
              text: r?.sales,
              theadId: "NetSales",
            });
          });
        if (tBody?.length > 1) tableBody?.push(tBody);
      });
    });
    return { tbody: tableBody, thead: tableHead };
  };

  const handleApply = () => {
    let error = false;
    if (portfolios === "") {
      toast("Select Portfolio", ToastTypes?.ERROR);
      error = true;
    } else if (
      year === null ||
      (year !== null && year?.getFullYear()?.toString() === "")
    ) {
      toast("Select year", ToastTypes?.ERROR);
      error = true;
    }
    var getData = {
      portfolio: portfolio,
      site: site,
      locality: location===defaultLocation?.label?'':location,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      year: year?.getFullYear(),
      limit: limit?.toString(),
      offset: offset?.toString()==='NaN'||offset===undefined?'0':offset?.toString(),
      authUserRole: authUser?.roleId ? authUser?.roleId : "",
    };

    if (
      error === false &&
      getData !== undefined &&
      getData?.limit !== "" &&
      getData?.offset !== ""
    ) {
      setLoader(true);
      api
        .post<APIResponse<{ records: SalesTradingDensityReportType[] }>>(
          `kpi/sales/tradeDensity`,
          getData,
          config
        )
        .then((response) => {
          if (response?.status === 200 && response?.data?.data) {
           
            const result = response?.data?.data?.records;
            setLoader(false);
            
            setSalesTradingDensityData(result);
            setCondition(false)
            if(authUser){
              const logProps1 = {
                action: 'Apply',
                event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Apply Clicked | Data Status: ${result?.[0]?.count && result[0]?.count > 0 ? 'Success' : 'Empty'}`
              };
              UserLog(logProps1)
            }
          }
          else {
            setSalesTradingDensityData([]);
            setLoader(false);
            setCondition(false)
          }
        })
        .catch((error) => {});
    } 
  };

  useEffect(()=>{    
    if(selectedOption?.isOutletUser){
      setDisableLocality(true);
    }
    else{
      setDisableLocality(false);
    }
  },[authUser, outletList,selectedOption]);

  useEffect(() => {
    if (portfolios !== "") {
      handleApply();
    } 
  }, [portfolios]);

  const handleCsvDownload = async () => {
    let Data = salesTradingDensityData;

    const d = { ...getDownloadData(Data) };
    const filteredHead = d?.thead
      ?.map((a) => {
        const foundObject = selectedRows
          ?.map((b) => {
            if (a?.text?.toString() === b?.toString()) {
              return a;
            }
          })
          ?.find((obj) => obj !== undefined);

        if (foundObject !== undefined) {
          return foundObject;
        }
      })
      ?.filter((obj) => obj !== undefined);
    const csvHead = filteredHead;
    const csvBody = d?.tbody;

    const head = [csvHead?.map((h) => h?.text || "") || []];
    const body =
      csvBody?.map((tr, i) => {
        return (
          csvHead?.map((th, j) => {
            const col = tr?.find((r) => r?.theadId === th?.id);
            return col?.text || "";
          }) || []
        );
      }) || [];

    const rows = [...head, ...body];
    const props = {
      rows: rows,
      fileName: "Sales Trade Density Report",
    };
    CSVdownload(props);
    if(authUser){
      const logProps1 = {
        action: 'Csv',
        event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Csv Clicked | Export Status: Success | Data Status: Success`
      };
      UserLog(logProps1)
    }
  };

  const handlePdfDownload = async () => {
    let Data = salesTradingDensityData;
    const d = { ...getDownloadData(Data) };
    const filteredHead = d?.thead
      ?.map((a) => {
        const foundObject = selectedRows
          ?.map((b) => {
            if (a?.text?.toString() === b?.toString()) {
              return a;
            }
          })
          ?.find((obj) => obj !== undefined);

        if (foundObject !== undefined) {
          return foundObject;
        }
      })
      ?.filter((obj) => obj !== undefined);
    const thead = filteredHead;
    const tbody = d?.tbody;

    const head = [thead?.map((h) => h?.text || "") || []];
    const body =
      tbody?.map((tr, i) => {
        return (
          thead?.map((th, j) => {
            const col = tr?.find((r) => r?.theadId === th?.id);
            return col?.text || "";
          }) || []
        );
      }) || [];

    const props = {
      head: head,
      body: body,
      fileName: "Sales Trade Density Report",
      title: "Sales Trade Density Report",
    };
    handleDownloadPDF(props);
    if(authUser){
      const logProps1 = {
        action: 'Pdf',
        event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Pdf Clicked | Export Status: Success | Data Status: Success`
      };
      UserLog(logProps1)
    }
  };

  const getTableData = () => {
    var tableHead: Thead[] = tHead;
    var tableBody: Tbody[][] = [];
    let Data = salesTradingDensityData;

    Data?.forEach((y, i) => {
      const brandArray = y?.record?.map((r, j) => r?.brand)?.filter(getOnlyUnique);

      brandArray?.forEach((br, j) => {
        var tBody: Tbody[] = [];
        const brandIndex = filteredBrand?.findIndex(
          (c) => c?.id !== undefined && c?.id?.toString() === br?.toString()
        );
        const brandName = filteredBrand[brandIndex]?.name;
        const brandId = br;

        tBody?.push({
          id: "Brand" + brandId + j,
          theadId: "Brand",
          children: brandName,
          text: brandName,
        });
        y?.record
          ?.filter((r) => r?.brand?.toString() === brandId?.toString())
          ?.forEach((r, i) => {
            tBody?.push({
              id: r?.sales?.toString() + i,
              children: r?.sales,
              text: r?.sales,
              theadId: "NetSales",
            });
          });
        if (tBody?.length > 1) tableBody?.push(tBody);
      });
    });
    return { tbody: tableBody, thead: tableHead };
  };

  useEffect(() => {
    const header = tHead
      ?.map((a) => a?.text)
      ?.filter((id): id is string => typeof id === "string" && id !== undefined);
    setSelectedRows(header);
  }, []);

  const portfolio = useMemo<number[]>(() => {
    return portfolios !== "" ? [parseInt(portfolios)] : [];
  }, [portfolios]);

  const site = useMemo<string[]>(() => {
    if (authUserSiteId) {
      return authUserSiteId?.split(",")?.map((s) => {
        return s?.toString();
      });
    } else {
      return [];
    }
  }, [authUserSiteId]);

  const brand = useMemo<number[]>(() => {
    if (brands !== "") {
      return brands !== "" ? [parseInt(brands)] : [];
    } else return []; //bcz no brand filter
  }, [brands]);

  const category = useMemo<number[]>(() => {
    return categories !== "" ? [parseInt(categories)] : [];
  }, [categories]);

  const subCategory = useMemo<number[]>(() => {
    return subCategories !== "" ? [parseInt(subCategories)] : [];
  }, [subCategories]);

  useEffect(()=>{
    let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
    setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
    const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl: b[0]?.logourl, 
      };
      setPortfolioDrop([val]);
    }
},[portfolioOption,selectedOption])

  useEffect(() => {
    let sid = siteData[0] && siteData[0]?.id ? siteData[0]?.id?.toString() : "";
    setSites(selectedOption?.site ? selectedOption?.site : sid);
  }, [siteData, selectedOption]);

  useEffect(() => {
    var range = [];
    var num = Math?.ceil(length / limit);
    // let i = 1;

    for (let i = 1; i <= num; i++) {
      range?.push(i);
    }
    setRange(range);
  }, [length, limit]);

  useEffect(()=>{
    setLocation(selectedOption.location? selectedOption.location:'')
    const b = localityOption.filter((a)=>a?.area?.toString()===selectedOption.location?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.area,
        imgUrl:'', 
      };
      setLocationDrop([val]);
    }
    },[localityOption,selectedOption])
  
    useEffect(()=>{
      setCategories(selectedOption.category ? selectedOption.category:'');
      const b = categoryOption.filter((a)=>a?.id?.toString()===selectedOption.category?.toString())
      if (b?.length > 0 && b[0]?.id !== undefined) {
        const val: DropDownOption = {
          value: b[0]?.id, 
          label: b[0]?.name,
          imgUrl:'', 
        };
        setCatDrop([val]);
      }
      },[categoryOption,selectedOption])
      
      
      useEffect(()=>{
      setSubCategories(selectedOption.subCategory ? selectedOption.subCategory:'');
      const b = subCategoryOption.filter((a)=>a?.id?.toString()===selectedOption.subCategory?.toString())
      if (b?.length > 0 && b[0]?.id !== undefined) {
        const val: DropDownOption = {
          value: b[0]?.id, 
          label: b[0]?.name,
          imgUrl:'', 
        };
        setSubcatDrop([val]);
      }
      },[subCategoryOption,selectedOption])

  useEffect(() => {
    if (sites !== ""&&selectedOption.isOutletUser===true) {
      let siteCurrencyObject = siteOption?.find(
        (s) => s?.id?.toString() === sites?.toString()
      );
      setValueIn(
        siteCurrencyObject?.currencycode +
          " | " +
          siteCurrencyObject?.valuecaption
      );
    } 
    else if(portfolios !== ""&&selectedOption.isOutletUser===false){
      let portfolioCurrencyObject = portfolioOption?.find(
        (s) => s?.id?.toString() === portfolios?.toString()
      );
      setValueIn(
        portfolioCurrencyObject?.reportingcurrency +
          " | " +
          portfolioCurrencyObject?.valuecaption
      );
    }
    else setValueIn("");
  }, [sites, siteOption,selectedOption]);

  useEffect(() => {
    if (salesTradingDensityData?.length > 0)
      setLength(
        salesTradingDensityData[0]?.count
          ? salesTradingDensityData[0]?.count
          : 0
      );
  }, [salesTradingDensityData]);

  useEffect(() => {
    var getData = {
      portfolio: portfolio,
    };

    if (portfolio?.length > 0 && getData !== undefined) {
      api
        .post<
          APIResponse<{ records: CatSubCatCompanyWithBrandRelationDataType[] }>
        >(`filter/catSubcatCompanyRelationWithBrand`, getData, config)
        .then((response) => {
          if (response?.status === 200 && response?.data?.data) {
            const result = response?.data?.data?.records;
            setCatSubCatCompanyWithBrandRelationData(result);
          }
        })
        .catch((error) => {});
    } else {
      setCatSubCatCompanyWithBrandRelationData([]);
    }
  }, [portfolio]);

  const colors = [
    COLORS?.COLOR1,
    COLORS?.COLOR2,
    COLORS?.COLOR3,
    COLORS?.COLOR4,
    COLORS?.COLOR5,
    COLORS?.COLOR6,
    COLORS?.COLOR7,
    COLORS?.COLOR8,
  ];

  useEffect(()=>{
    if(authUser){
    const logProps1 = {
      action:`Visit`,
      event: `${pageName?.pathname?.replace("\\", " ")} page | Visited `
    };
    UserLog(logProps1)
  }
  },[])


  return (
    <UserLayout>
      <div className="card background-transparent p-1">
        <div className="row">
          <div
            className="col-lg-4 wow fadeInLeft ps-0"
          >
            <h4 className="b-title">Trading Density</h4>
          </div>

          <div className="col-lg-8 wow fadeInRight">
            <div className="row">
              <div className="col-sm-6 col-md-4 col-lg-4">
                {/* <FormInput2
                  name="Portfolio"
                  label=""
                  labelClassName="required"
                  value={portfolios}
                  onChange={handlePortfolioChange}
                  placeholder="Select"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select</option>
                  {portfolioData?.map((p, i) => {
                    return (
                      <Option value={p?.id} key={i}>
                        {p?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                 {/* <SingleSelect
                  options={[
                    defaultPortfolio,
                    ...portfolioData?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: s?.logourl,
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={portfoliosOption}
                  setSelectedOptions={handlePortfolioChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Portfolio"
                  // filterText=""
                /> */}
                  <SingleSelect1
                      options={portfolioData.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={portfolioDrop}
                      setSelectedOptions={handlePortfolioDrop}
                      placeHolder="Select Portfolio"
                      onClear={handleClearPortfolio}
                      disabled = {disableLocality}
                    />
              </div>
              
              <div className="col-sm-6 col-md-4 col-lg-4">
              {/* <FormInput2
                  name="Location"
                  label=""
                  labelClassName="required"
                  value={location}
                  onChange={handleLocationChange}
                  placeholder="Select Locality"
                  containerClass="mb-1"
                  disabled={disableLocality}
                  type="select"
                >
                  <option value="">Select Locality</option>
                  {localityOption?.map((s, i) => {
                    return (
                      <Option value={s?.area} key={i}>
                        {s?.area}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                {/* <SingleSelect
                  options={[
                    defaultLocation,
                    ...localityOption?.sort(function (a, b) {
                      if (a?.area < b?.area) {
                        return -1;
                      }
                      if (a?.area > b?.area) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.area,
                          imgUrl: '',
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={locationOption}
                  setSelectedOptions={handleLocationChange}
                  disabled={disableLocality}
                  placeHolder="Select Portfolio"
                  // filterText=""
                /> */}
                  <SingleSelect1
                      options={localityOption.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.area?c?.area:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={locationDrop}
                      setSelectedOptions={handleLocationDrop}
                      placeHolder="Select Locality"
                      onClear={handleClearLocation}
                      disabled = {disableLocality}
                    />
              </div>
            </div>

            <div className="row mt-1">
              <div className="col-sm-6 col-md-4 col-lg-4">
                {/* <FormInput2
                  name="Trade Category"
                  label=""
                  labelClassName="required"
                  value={categories}
                  onChange={handleCategoryChange}
                  placeholder="Select Trade Category"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select Trade Category</option>
                  {categoryOption?.map((s, i) => {
                    return (
                      <Option value={s?.id} key={i}>
                        {s?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                  {/* <SingleSelect
                  options={[
                    defaultTradeCategory,
                    ...categoryOption?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: '',
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={categoriesOption}
                  setSelectedOptions={handleCategoryChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Trade Category"
                  // filterText=""
                /> */}
                   <SingleSelect1
                      options={categoryOption.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={catDrop}
                      setSelectedOptions={handleCatDrop}
                      placeHolder="Select Trade Category"
                      onClear={handleClearCat}
                      disabled = {disableLocality}
                    />
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                {/* <FormInput2
                  name="Trade Sub Category"
                  label=""
                  labelClassName="required"
                  value={subCategories}
                  onChange={handleSubCategoryChange}
                  placeholder="Select Trade Sub Category"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select Trade Sub Category</option>
                  {subCategoryFilteredByCategory?.map((s, i) => {
                    return (
                      <Option value={s?.id} key={i}>
                        {s?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                {/* <SingleSelect
                  options={[
                    defaultTradeSubCategory,
                    ...subCategoryFilteredByCategory?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: '',
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={subCategoriesOption}
                  setSelectedOptions={handleSubCategoryChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Trade Sub Category"
                  // filterText=""
                /> */}
                 <SingleSelect1
                      options={subCategoryFilteredByCategory.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={subcatDrop}
                      setSelectedOptions={handleSubcatDrop}
                      placeHolder="Select Trade Sub Category"
                      onClear={handleClearSubcat}
                      disabled = {disableLocality}
                    />
              </div>
            </div>
          </div>
        </div>
      </div>

      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="row">
            <div className="col-12">
              <div className="card mt-3 widget_div" onMouseEnter={() => setButtonVisible(true)} onMouseLeave={() => setButtonVisible(false)}>
                {(<button type="button" className="expandIconBtn" onClick={showExpandModalHandler} ><i><FontAwesomeIcon icon={faWindowMaximize} size="lg" title="Open in Popup"/></i></button>)}
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12 col-md-6">
                      <div className="float-start">
                        <h5 className="header-title">
                          <img src={chartIcon} alt="icon"></img>Trading Density
                        </h5>
                      </div>
                      <div className="col-lg-12 col-sm-12 col-md-6">
                        <div className="float-end hstack gap-2">
                          <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                            <div className="DateContainer">
                              <span className="dateInput">
                                <DatePicker
                                  id="DatePicker"
                                  // type="string"
                                  className="text-center fw-bold form-control"
                                  selected={year}
                                  onChange={(date: any) => setYear(date)}
                                  showYearPicker
                                  dateFormat="yyyy"
                                  yearItemNumber={8}
                                  //     required
                                />
                              </span>
                              <span className="icon">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14.25 2.6001C14.4709 2.6001 14.65 2.77918 14.65 3.0001V4.26685H16.125C16.7141 4.26685 17.2873 4.47445 17.7165 4.85604C18.1474 5.23898 18.4 5.76918 18.4 6.33351V9.66685V16.3335C18.4 16.8979 18.1474 17.428 17.7165 17.811C17.2873 18.1926 16.7141 18.4002 16.125 18.4002H4.87498C4.28582 18.4002 3.71269 18.1926 3.2834 17.811C2.85259 17.428 2.59998 16.8978 2.59998 16.3335V9.66685V6.33351C2.59998 5.76918 2.85259 5.23898 3.2834 4.85604C3.71269 4.47445 4.28582 4.26685 4.87498 4.26685H6.34998V3.0001C6.34998 2.77918 6.52906 2.6001 6.74998 2.6001C6.97089 2.6001 7.14998 2.77918 7.14998 3.0001V4.26685H13.85V3.0001C13.85 2.77918 14.0291 2.6001 14.25 2.6001ZM17.6 6.33351V9.26685H3.39998V6.33351C3.39998 6.01379 3.54245 5.69614 3.8149 5.45396C4.08888 5.21043 4.46957 5.06685 4.87498 5.06685H6.34998V6.33343C6.34998 6.55434 6.52906 6.73343 6.74998 6.73343C6.97089 6.73343 7.14998 6.55434 7.14998 6.33343V5.06685H13.85V6.33343C13.85 6.55434 14.0291 6.73343 14.25 6.73343C14.4709 6.73343 14.65 6.55434 14.65 6.33343V5.06685H16.125C16.5304 5.06685 16.9111 5.21043 17.1851 5.45396C17.4575 5.69614 17.6 6.01379 17.6 6.33351ZM17.6 10.0668H3.39998V16.3335C3.39998 16.6532 3.54245 16.9709 3.8149 17.2131C4.08888 17.4566 4.46957 17.6002 4.87498 17.6002H16.125C16.5304 17.6002 16.9111 17.4566 17.1851 17.2131C17.4575 16.9709 17.6 16.6532 17.6 16.3335V10.0668ZM10.5 12.6001C10.1595 12.6001 9.82478 12.7199 9.57132 12.9452C9.31632 13.1719 9.16248 13.4901 9.16248 13.8334C9.16248 14.1768 9.31632 14.495 9.57132 14.7217C9.82478 14.947 10.1595 15.0668 10.5 15.0668C10.8405 15.0668 11.1752 14.947 11.4286 14.7217C11.6836 14.495 11.8375 14.1768 11.8375 13.8334C11.8375 13.4901 11.6836 13.1719 11.4286 12.9452C11.1752 12.7199 10.8405 12.6001 10.5 12.6001ZM10.1028 13.5431C10.201 13.4559 10.3432 13.4001 10.5 13.4001C10.6567 13.4001 10.799 13.4559 10.8971 13.5431C10.9938 13.629 11.0375 13.7347 11.0375 13.8334C11.0375 13.9321 10.9938 14.0378 10.8971 14.1237C10.799 14.211 10.6567 14.2668 10.5 14.2668C10.3432 14.2668 10.201 14.211 10.1028 14.1237C10.0062 14.0378 9.96248 13.9321 9.96248 13.8334C9.96248 13.7347 10.0062 13.629 10.1028 13.5431Z"
                                    fill="#6C757D"
                                  ></path>
                                </svg>
                              </span>
                            </div>
                          </div>
                          <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleApply}
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="m-0 my-2 p-0 hr" />
                  {salesTradingDensityData[0]?.record?.length !== undefined &&
                    salesTradingDensityData[0]?.record?.length > 0 && (
                      <div>{"*Value in " + valueIn}</div>
                    )}

                  {salesTradingDensityData[0]?.record?.length !== undefined &&
                  salesTradingDensityData[0]?.record?.length > 0 ? (
                    <BubbleChart
                      datasets={(() => {
                        let ydata: { name: string; data: any[] }[] = [];
                        salesTradingDensityData?.forEach((y, i) => {
                          // const index = portfolioOption?.findIndex(p => p?.id !== undefined && p?.id?.toString() === y?.portfolio?.toString())
                          // const name = portfolioOption[index]?.name
                          const brandArray = y?.record
                            ?.map((r, j) => r?.brand)
                            ?.filter(getOnlyUnique);

                          brandArray?.forEach((b, i) => {
                            const brandIndex = filteredBrand?.findIndex(
                              (c) =>
                                c?.id !== undefined &&
                                c?.id?.toString() === b?.toString()
                            );
                            const brandName = filteredBrand[brandIndex]?.name;
                            const brandId = b;

                            let d1 = y?.record
                              ?.filter(
                                (sw) =>
                                  sw?.brand?.toString() === brandId?.toString()
                              )
                              ?.map((d) => (d?.sales ? parseFloat(d?.sales) : 0));

                            if (d1?.length > 0) {
                              ydata?.push({
                                name: brandName,
                                data: [
                                  { x: "", y: 0, z: 0 }, //for starting space so that the bubble wont be half at first
                                ],
                              });

                              let l = brandArray?.length + 1;
                              for (let i = 0; i < l; i++) {
                                ydata[i]?.data?.push({ x: " ", y: 0, z: 0 });
                              }

                              // ydata?.push({
                              //     name: brandName,
                              //     data: [
                              //         { x: "", y: 0, z: 0 },//for starting space so that the bubble wont be half at first
                              //         { x: brandName, y: d1[0], z: 20 }]
                              // })

                              let positionIndex = brandArray?.findIndex(
                                (ba) => ba === brandId
                              );

                              // let bubbleSize = d1[0]?.toString()?.length <= 3
                              //     ? 15
                              //     : d1[0]?.toString()?.length <= 5
                              //         ? 35
                              //         : 50
                              let bubbleSize =
                                d1[0] <= 5000
                                  ? 10
                                  : d1[0] <= 15000
                                  ? 20
                                  : d1[0] <= 30000
                                  ? 30
                                  : d1[0] <= 40000
                                  ? 40
                                  : d1[0] <= 60000
                                  ? 50
                                  : 60;
                              ydata[i].data[positionIndex + 1] = {
                                x: brandName,
                                y: d1[0],
                                z: bubbleSize,
                              };

                              let bd = brandArray?.filter(
                                (bd) => bd !== brandId
                              );
                              bd?.forEach((be) => {
                                const bIndex = filteredBrand?.find(
                                  (c) =>
                                    c?.id !== undefined &&
                                    c?.id?.toString() === be?.toString()
                                );
                                const bName = bIndex?.name;
                                let positionIndex = brandArray?.findIndex(
                                  (ba) => ba === be
                                );
                                ydata[i].data[positionIndex + 1] = {
                                  x: bName,
                                  y: 0,
                                  z: 0,
                                };
                              });

                              ydata[i]?.data?.push(
                                { x: " ", y: 0, z: 0 } //for ending space so that the bubble wont be half at last
                              );
                            }
                          });
                        });

                        return ydata;
                      })()}
                      labels={(() => {
                        let label: string[] = [];
                        salesTradingDensityData?.forEach((y, i) => {
                          const index = portfolioOption?.findIndex(
                            (p) =>
                              p?.id !== undefined &&
                              p?.id?.toString() === y?.portfolio?.toString()
                          );
                          // const name = portfolioOption[index]?.name;

                          filteredBrand?.forEach((b) => {
                            let d1 = y?.record
                              ?.filter(
                                (sw) =>
                                  sw?.brand?.toString() === b?.id?.toString()
                              )
                              ?.map((d) => (d?.sales ? parseFloat(d?.sales) : 0));

                            if (d1?.length > 0) {
                              label?.push(b?.name);
                            }
                          });
                        });
                        return label;
                      })()}
                      colors={[
                        colors[0],
                        colors[1],
                        colors[2],
                        colors[3],
                        colors[4],
                        colors[5],
                        colors[6],
                        colors[7],
                      ]}
                      title={(() => {
                        const txt = `Trading Density`;
                        return txt;
                      })()}
                      subtitle={(() => {
                        let subtxt = `\u3010Company\u3011: ${pname}`;
                        if (location) {
                          subtxt += `\u3010Locality\u3011: ${location}`;
                        }
                        if (categories?.length > 0 && categories !== undefined) {
                          const categoryIndex = categoryOption?.findIndex(
                            (a) => a?.id?.toString() === categories?.toString()
                          );
                          const categoryName =
                            categoryOption[categoryIndex]?.name;
                          subtxt += ` \n\u3010TradeCategory\u3011: ${categoryName}`;
                        }
                        if (subCategories?.length > 0) {
                          const subcategoryIndex = subCategoryOption?.findIndex(
                            (a) =>
                              a?.id?.toString() === subCategories?.toString()
                          );
                          const subcatName =
                            subCategoryOption[subcategoryIndex]?.name;
                          subtxt += ` \u3010TradeSubcategory\u3011: ${subcatName}`;
                        }
                        subtxt += ` \u3010Year\u3011: ${year?.getFullYear()}`;
                        return subtxt;
                      })()}
                      exportfilename={"TradingDensity"}
                    />
                  ) : (
                    <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                      <p className="empty-data">No Records Found</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card mt-3">
                <div className="card-body">
                  <TransactionTable
                    data={[]}
                    {...getTableData()}
                    title="Top 10 brands by Trading Density"
                    downloadCSV={true}
                    downloadPDF={true}
                    fileName="Sales Trade Density"
                    onClickCSV={handleCsvDownload}
                    onClickPDF={handlePdfDownload}
                    range={range}
                    valueInString={valueIn}
                    onSelectedRowsChange={handleSelectedRowsChange}
                  />
                </div>
              </div>
            </div>
          </div>

          {showModal && (
        <Modal
        headerText={"Trading Density"}
        visible={showModal}
        onClose={() => setShowModal(false)}
        size="xl"
        centered
        classname="widget-container-single" > 
		<div className="card-body">

                  {salesTradingDensityData[0]?.record?.length !== undefined &&
                  salesTradingDensityData[0]?.record?.length > 0 ? (
                    <BubbleChart
                      datasets={(() => {
                        let ydata: { name: string; data: any[] }[] = [];
                        salesTradingDensityData?.forEach((y, i) => {
                          const brandArray = y?.record
                            ?.map((r, j) => r?.brand)
                            ?.filter(getOnlyUnique);

                          brandArray?.forEach((b, i) => {
                            const brandIndex = filteredBrand?.findIndex(
                              (c) =>
                                c?.id !== undefined &&
                                c?.id?.toString() === b?.toString()
                            );
                            const brandName = filteredBrand[brandIndex]?.name;
                            const brandId = b;

                            let d1 = y?.record
                              ?.filter(
                                (sw) =>
                                  sw?.brand?.toString() === brandId?.toString()
                              )
                              ?.map((d) => (d?.sales ? parseFloat(d?.sales) : 0));

                            if (d1?.length > 0) {
                              ydata?.push({
                                name: brandName,
                                data: [
                                  { x: "", y: 0, z: 0 }, 
                                ],
                              });

                              let l = brandArray?.length + 1;
                              for (let i = 0; i < l; i++) {
                                ydata[i].data?.push({ x: " ", y: 0, z: 0 });
                              }

                              let positionIndex = brandArray?.findIndex(
                                (ba) => ba === brandId
                              );
                              let bubbleSize =
                                d1[0] <= 5000
                                  ? 10
                                  : d1[0] <= 15000
                                  ? 20
                                  : d1[0] <= 30000
                                  ? 30
                                  : d1[0] <= 40000
                                  ? 40
                                  : d1[0] <= 60000
                                  ? 50
                                  : 60;
                              ydata[i].data[positionIndex + 1] = {
                                x: brandName,
                                y: d1[0],
                                z: bubbleSize,
                              };

                              let bd = brandArray?.filter(
                                (bd) => bd !== brandId
                              );
                              bd?.forEach((be) => {
                                const bIndex = filteredBrand?.find(
                                  (c) =>
                                    c?.id !== undefined &&
                                    c?.id?.toString() === be?.toString()
                                );
                                const bName = bIndex?.name;
                                let positionIndex = brandArray?.findIndex(
                                  (ba) => ba === be
                                );
                                ydata[i].data[positionIndex + 1] = {
                                  x: bName,
                                  y: 0,
                                  z: 0,
                                };
                              });

                              ydata[i]?.data?.push(
                                { x: " ", y: 0, z: 0 } 
                              );
                            }
                          });
                        });
                        return ydata;
                      })()}
                      labels={(() => {
                        let label: string[] = [];
                        salesTradingDensityData?.forEach((y, i) => {
                          
                          filteredBrand?.forEach((b) => {
                            let d1 = y?.record
                              ?.filter(
                                (sw) =>
                                  sw?.brand?.toString() === b?.id?.toString()
                              )
                              ?.map((d) => (d?.sales ? parseFloat(d?.sales) : 0));

                            if (d1?.length > 0) {
                              label?.push(b?.name);
                            }
                          });
                        });
                        return label;
                      })()}
                      colors={[
                        colors[0],
                        colors[1],
                        colors[2],
                        colors[3],
                        colors[4],
                        colors[5],
                        colors[6],
                        colors[7],
                      ]}
                      title={(() => {
                        const txt = `Trading Density`;
                        return txt;
                      })()}
                      subtitle={(() => {
                        let subtxt = `\u3010Company\u3011: ${pname}`;
                        if (location) {
                          subtxt += `\u3010Locality\u3011: ${location}`;
                        }
                        if (categories?.length > 0 && categories !== undefined) {
                          const categoryIndex = categoryOption?.findIndex(
                            (a) => a?.id?.toString() === categories?.toString()
                          );
                          const categoryName =
                            categoryOption[categoryIndex]?.name;
                          subtxt += ` \n\u3010TradeCategory\u3011: ${categoryName}`;
                        }
                        if (subCategories?.length > 0) {
                          const subcategoryIndex = subCategoryOption?.findIndex(
                            (a) =>
                              a?.id?.toString() === subCategories?.toString()
                          );
                          const subcatName =
                            subCategoryOption[subcategoryIndex]?.name;
                          subtxt += ` \u3010TradeSubcategory\u3011: ${subcatName}`;
                        }
                        subtxt += ` \u3010Year\u3011: ${year?.getFullYear()}`;
                        return subtxt;
                      })()}
                      exportfilename={"TradingDensity"}
                    />
                  ) : (
                    <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                      <p className="empty-data">No Records Found</p>
                    </div>
                  )}
                </div>
		
		</Modal>)}
        </>
      )}
    </UserLayout>
  );
};
export default SalesTradingDensityReport;
